import Banner from 'assets/images/banner.png';
import Globe from 'assets/images/globe.png';
import RectAngle from 'assets/images/rectangle.png';
import Navbar from 'components/global/navbar';

const Hero = () => {
    return (
        <div className='relative h-screen overflow-hidden'>
            <div className='relative z-10'>
                <Navbar />
            </div>
            <div className='absolute top-1/2 -translate-y-1/2 w-full lg:px-20 md:px-12 sm:px-8 px-4  flex flex-col justify-center'>
                <h1 className='md:text-[45px] sm:text-[35px] text-[25px] lg:leading-[1.2] text-primary sm:font-bold font-semibold'>
                    We’ve made advertising on digital <br /> 
                    billboards so easy <br /> 
                    and simple
                </h1>
                <h6 className='py-6 sm:text-xl text-base text-dark font-medium'>You won’t believe us!</h6>
                <div>
                    <button className="btn-primary sm:py-3 py-2 ">
                        Create Your Bilcard
                    </button>
                </div>
            </div>
            <div className='absolute top-0 right-0 flex items-end justify-end -z-[2]'>
                <img src={Banner} alt="Banner bg" className='w-[90%]' />
            </div>
            <div className='absolute lg:-bottom-[30%] sm:-bottom-[10%] -bottom-[5%]  left-0 -z-[1]'>
                <img src={RectAngle} alt="Rectangle" />
            </div>
            <div>
                <img 
                src={Globe} 
                alt="Globe" 
                className='rotate absolute -bottom-4 left-[42%] -translate-x-1/2 lg:w-[400px] md:w-[350px] w-[300px]  -z-[2]'
                />
            </div>
        </div>
    )
}

export default Hero